export default "__VITE_ASSET__DoTI0n3S__"